// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604101038/js/" + chunkId + "." + {"44":"49e1945a","225":"baff43e4","481":"60cbc1de","486":"e1033d70","770":"204238ce"}[chunkId] + ".0.3334459346898919.chunk.js";
};